<template>
    <v-flex xs4>
      <div
        class="btn btn--outline btn--depressed primary--text"
        :class="active ? 'btn--active' : ''"
        v-ripple
      >
        <v-card-text
          primary-title
          class="primary--text text-xs-center px-1"
          @click="$emit('selectCreativePath', path.value)"
        >
          <v-icon
            large
            class="primary--text"
            style="vertical-align: middle"
          >
            {{ path.icon }}
          </v-icon>
          {{ path.title }}
        </v-card-text>
      </div>
    </v-flex>
</template>

<script>
  export default {
    name: 'message-selector-element',
    data () {
      return {}
    },
    props: {
      path: {
        type: Object,
        default: () => {}
      },
      active: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      toUpperCase (value) {
        return value.toUpperCase()
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn {
  border-style: solid;
  border-color: #6099D8;
  border-width: 1px;
  border-radius: 10px;
  min-height: 70px;
  cursor: pointer
}

.btn:hover {
  background-color: #e4eef9;
  box-shadow:none
}
.btn--active {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: #FFFFFF;
  .v-card__text, .v-icon {
    color: #FFFFFF!important;
  }
}
.btn--active:hover {
  background-color: #0d47a1;
  color: #FFFFFF;
  .v-card__text, .v-icon {
    color: #FFFFFF!important;
  }
}
</style>
